import { createAction, props } from '@ngrx/store';

import { TrailerItem, TrailerList } from '../../app/portal/pages/trailers/trailers.types';

/**
 * Действие для загрузки списка прицепов.
 */
export const loadTrailers = createAction('[Trailers] Load Trailers');

/**
 * Действие для успешной загрузки списка прицепов.
 *
 * @property {TrailerList} list - Список прицепов.
 */
export const loadTrailersSuccess = createAction(
  '[Trailers] Load Trailers Success',
  props<{ list: TrailerList }>(),
);

/**
 * Действие для обработки ошибки при загрузке списка прицепов.
 *
 * @property {string} error - Сообщение об ошибке.
 */
export const loadTrailersFailure = createAction(
  '[Trailers] Load Trailers Failure',
  props<{ error: string }>(),
);

/**
 * Действие для добавления нового прицепа.
 *
 * @property {TrailerItem} trailer - Новый прицеп.
 */
export const addTrailer = createAction(
  '[Trailers] Add Trailers',
  props<{ trailer: TrailerItem }>(),
);

/**
 * Действие для обновления данных прицепа.
 *
 * @property {string} id - Идентификатор прицепа.
 * @property {Partial<TrailerItem>} changes - Изменения в данных прицепа.
 */
export const updateTrailer = createAction(
  '[Trailers] Update Trailers',
  props<{ id: number; changes: Partial<TrailerItem> }>(),
);

/**
 * Действие для обновления нескольких прицепов одновременно.
 *
 * @property {Array<{ id: number; changes: Partial<TrailerItem> }>} updates - Массив обновлений прицепов.
 */
export const updateMultipleTrailers = createAction(
  '[Trailers] Update Multiple Trailers',
  props<{ updates: { id: number; changes: Partial<TrailerItem> }[] }>(),
);

/**
 * Действие для удаления прицепа.
 *
 * @property {string} id - Идентификатор прицепа.
 */
export const deleteTrailer = createAction('[Trailers] Delete Trailers', props<{ id: string }>());
